import { PulseLoader } from "react-spinners";

export const CustomLoader = () => {
  return (
    <div className="d-flex justify-content-center align-items-center py-4">
      <PulseLoader color="#0d6efd" size={15} margin={5} />
    </div>
  );
};
